import { render } from "./SectionExpander.vue?vue&type=template&id=31cbd18a"
import script from "./SectionExpander.vue?vue&type=script&lang=js"
export * from "./SectionExpander.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__